const dashboard = "/dashboard"
const masterAdmin = "/master-admin"
const prod = !false

const server = "https://api.akisolutions.com.ng/api/"
const localhost = "http://localhost:8000/api/" ///192.168.43.95:8000

const localImageLink = "http://localhost:8000/images/"
const remoteImageLink = "http://"

const routes = {
    master: masterAdmin,
    apiServer: (prod ? server : localhost),
    public: {
        home: "/",
        login: "/login",
        eVoting: "/eVoting",
        contact: "/contact",
        users: "/users",
        events: "/events",
        editEvent: "/editEvent",
        addEvent: "/addEvents",
        editUser: "/editUser",
        transactions: "/transactions",

        editSection: "/editSection",
        sections: "/sections",
        addSection: "/addSection",
        createUser: "/createUser",
        profile: "/profile",
        messageMember: "/messageMember",
        messageSectionMember: "/messageSectionMember",
    },
    api: {
        getImage: prod ? remoteImageLink : localImageLink,

        adminLogin: (prod ? server : localhost) + 'auth/adminLogin',
        adminLogOut: (prod ? server : localhost) + 'auth/logout',

        getSections: (prod ? server : localhost) + 'section',
        addSections: (prod ? server : localhost) + 'store-section',
        editSection: (prod ? server : localhost) + 'update-section',
        deleteSection: (prod ? server : localhost) + 'delete-section',

        getEvent: (prod ? server : localhost) + 'events',
        addEvent: (prod ? server : localhost) + 'store-events',
        editEvent: (prod ? server : localhost) + 'update-event',
        deleteEvent: (prod ? server : localhost) + 'delete-event',

        createUser: (prod ? server : localhost) + 'auth/register',
        messageMember: (prod ? server : localhost) + 'message-member',

        getMember: (prod ? server : localhost) + 'getMembers',
        editMember: (prod ? server : localhost) + 'update-member',
        locations: {
            getSection: 'sections',
            updateProfile: "update_member_profile",
            getUserProfile: "user-profile",
            adminLogin: "adminLogin",
            addSections: 'store-section',
            editSection: 'update-section',
            deleteSection: 'delete-section',
            getEvent: 'events',
            addEvent: 'store-events',
            editEvent: 'update-event',
            deleteEvent: 'delete-event',

            createUser: 'register',
            messageMember: 'message-member',
            message_section_members: 'message_section_members',

            getMember: 'getMembers',
            editMember: 'update-member',

            adminLogOut: 'logout',

        }
    },
    dashboard: {
        index: "/dashboard",
        dashboard: dashboard + "/dashboard",
    },
    masterAdmin: {
        index: masterAdmin,
        dashboard: masterAdmin + "/dashboard",
    }
}

export default routes